import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import gotenbergLogo from '../Images/gotenberg.svg'
import { Link } from 'react-router-dom';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Navigation Bar - Fixed at top */}
      <nav className="shadow-md fixed w-full top-0 z-50 bg-[#F8F7FF]">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 ">
          <div className="flex justify-between items-center h-16 max-w-[1200px] mx-auto">
            {/* LEFT SIDE - LOGO */}
            <div className="w-44">
              <Link to="/"><img src={gotenbergLogo} alt='' title='Gotenberg Solution - A specialized printing company'/></Link>
            </div>

            {/* RIGHT SIDE - DESKTOP MENU (hidden on mobile) */}
            <div className="hidden md:flex md:items-center md:space-x-8">
              <a href="/" className="text-gray-900 hover:text-[#C13E39] px-3 py-2 font-medium">
                Home
              </a>
              <a href="/About" className="text-gray-900 hover:text-[#C13E39] px-3 py-2 font-medium">
                About
              </a>
              <a href="/Services" className="text-gray-900 hover:text-[#C13E39] px-3 py-2 font-medium">
                Services
              </a>
              {/* <a href="/design" className="text-gray-900 hover:text-[#C13E39] px-3 py-2 font-medium">
                Design
              </a> */}
              {/* <a href="/decals" className="text-gray-900 hover:text-[#C13E39] px-3 py-2 font-medium">
                Decals
              </a> */}
              <a href="/contact" className="text-gray-900 hover:text-[#C13E39] px-3 py-2 font-medium">
                Contact
              </a>
            </div>

            {/* MOBILE MENU BUTTON (hidden on desktop) */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-gray-900 hover:text-[#C13E39] focus:outline-none"
              >
                {isOpen ? (
                  <FaTimes className="h-6 w-6" />
                ) : (
                  <FaBars className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Spacer to prevent content from being hidden behind fixed nav */}
      <div className="h-16"></div>

      {/* MOBILE MENU - Pushes content down when open */}
      {isOpen && (
        <div className="md:hidden bg-[#F8F7FF] shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a
              href="/"
              className="block px-3 py-2 text-gray-900 hover:text-[#C13E39] rounded-md text-base font-medium "
              onClick={() => setIsOpen(false)}
            >
              Home
            </a>
            <a
              href="/About"
              className="block px-3 py-2 text-gray-900 hover:text-[#C13E39] rounded-md text-base font-medium"
              onClick={() => setIsOpen(false)}
            >
              About
            </a>
            <a
              href="/Services"
              className="block px-3 py-2 text-gray-900 hover:text-[#C13E39] rounded-md text-base font-medium"
              onClick={() => setIsOpen(false)}
            >
              Services
            </a>
            {/* <a
              href="/"
              className="block px-3 py-2 text-gray-900 hover:text-[#C13E39] rounded-md text-base font-medium"
              onClick={() => setIsOpen(false)}
            >
              Design
            </a> */}
            {/* <a
              href="/"
              className="block px-3 py-2 text-gray-900 hover:text-[#C13E39] rounded-md text-base font-medium"
              onClick={() => setIsOpen(false)}
            >
              Decals
            </a> */}
            <a
              href="/Contact"
              className="block px-3 py-2 text-gray-900 hover:text-[#C13E39] rounded-md text-base font-medium"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;